// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-text[data-v-477cda03] {\n  height: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
